import Swiper from "swiper";
import { $t } from "../i18n";

export default {
  init() {
    const aboutSwiper = $(".about-slider-container");
    const aboutVideo = $(".about-video");

    aboutVideo.on("click", function() {
      $(this).addClass("active");
    });

    $(window).on("load", () => {
      const cvFileWrap = $(".wpcf7-form-control-wrap.cv");
      const cvFileWrapHtml = cvFileWrap.html();
      cvFileWrap.html("");

      $(document).on(
        "change",
        ".wpcf7-form-control-wrap.cv input[type=file]",
        function(e) {
          cvFileWrap.find("span.file-name").html(e.target.files[0].name);
        }
      );

      cvFileWrap.append(
        '<div class="file-cv-wrap"><span class="file-name">' +
          $t("העלה קובץ קורות חיים") +
          "</span>" +
          cvFileWrapHtml +
          "</div>"
      );

      new Swiper(aboutSwiper, {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        on: {
          init: function() {
            // $(this)[0].slideTo(($(this)[0].slides.length - 1) / 2)
          }
        },
        navigation: {
          nextEl: ".about-slider .swiper-button-next",
          prevEl: ".about-slider .swiper-button-prev"
        },
        pagination: {
          el: ".about-slider .swiper-pagination",
          type: "bullets"
        }
      });
    });
  },

  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  }
};
